import {
  type RelatedNewsItem,
  type RelatedNewsNormalized,
  type NewsRelatedLetter,
} from 'hb-react/shared/apps/News/types';

/**
 * Normalizes RelatedNewsItem (from API response) to RelatedNewsNormalized format
 * @param item - The related news item from the API response (camelCase after axios transformation)
 * @returns Normalized related news item for component consumption
 */
export const normalizeRelatedNewsItem = (
  item: RelatedNewsItem,
): RelatedNewsNormalized => ({
  content: item.content,
  coverPicture: {
    previewUrl: item.coverPicture?.previewUrl || '',
    mediumUrl: item.coverPicture?.mediumUrl || '',
  },
  seoTitle: item.seoTitle || undefined,
  id: item.id,
  seoDescription: item.seoDescription || undefined,
  publishedAt: item.publishedAt,
  subject: item.subject,
});

/**
 * Normalizes NewsRelatedLetter (from legacy format) to RelatedNewsNormalized format
 * @param letter - The related news letter from the legacy format
 * @returns Normalized related news item for component consumption
 */
export const normalizeNewsRelatedLetter = (
  letter: NewsRelatedLetter,
): RelatedNewsNormalized => ({
  content: letter.content,
  coverPicture: {
    previewUrl: letter.newCoverPicture?.previewUrl || '',
    mediumUrl: letter.newCoverPicture?.mediumUrl || '',
  },
  id: letter.id.toString(),
  publishedAt: letter.feedableAt || letter.publishedAt,
  subject: letter.subject,
});
